export const validateRole = (role: string | null, accepted_role: string) => {
  if (role === accepted_role) {
    return true;
  }
  return false;
};
